<script>

import NavBar from './NavBar.vue';
import LoginComponent from './LoginComponent.vue';
//import LeftNavMenu from './LeftNavMenu.vue';


    export default {
    name: 'BasePage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LoginComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <!-- <LeftNavMenu /> -->
            <LoginComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>
